module.exports = __webpack_public_path__ + "static/media/ResumeLarsenClickable.7b8c102d.pdf";